import React from 'react'
import { cn } from '@/utils/cn'
import { useTheme } from '@/hooks/useTheme'

export interface SubtitleTextProps {
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary'
}

const SubtitleText: React.FC<SubtitleTextProps> = ({
  children,
  className,
  variant = 'primary'
}) => {
  const { isDark } = useTheme()
  const baseClasses = "font-heading font-bold text-2xl mb-4"

  const getVariantClasses = (variant: 'primary' | 'secondary') => {
    if (variant === 'primary') {
      return isDark ? "text-white" : "text-secondary-900"
    }
    return isDark ? "text-secondary-300" : "text-secondary-700"
  }

  const combinedClasses = cn(
    baseClasses,
    getVariantClasses(variant),
    className
  )

  return <h2 className={combinedClasses}>{children}</h2>
}

export { SubtitleText }